import { HttpClient } from '@angular/common/http'
import { Component, OnInit } from '@angular/core'
import { Auth } from '@angular/fire/auth'
import { FormGroup, FormBuilder } from '@angular/forms'
import { Router } from '@angular/router'
import { Client, ClientPrivate, clientsPath, adminClientsPath, Subscription } from '@parkupp/core'
import { query, collection, orderBy, limit } from 'firebase/firestore'
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'
import { ToastrService } from 'ngx-toastr'
import { collectionData } from 'rxfire/firestore'
import { combineLatest, map } from 'rxjs'
import { AdminService } from 'src/app/services/admin.service'
import { AuthenticationService } from 'src/app/services/authentication.service'
import { GlobalService } from 'src/app/services/global.service'
import { SubscriptionService } from 'src/app/services/subscription.service'

@Component({
    selector: 'app-admin-list-leads',
    templateUrl: './admin-list-leads.component.html',
    styleUrls: ['./admin-list-leads.component.scss'],
})
export class AdminListLeadsComponent implements OnInit {
    formGroup: FormGroup
    clients: Client[]
    clientsPrivate: ClientPrivate[]
    clientsMap: { [id: string]: ClientPrivate }
    modalRef?: BsModalRef
    loading = false
    clientKey: string
    subscriptions: Subscription[] = []

    constructor(
        public globalService: GlobalService,
        public auth: Auth,
        private adminSvc: AdminService,
        private router: Router,
        private http: HttpClient,
        private toastrService: ToastrService,
        private formBuilder: FormBuilder,
        private authService: AuthenticationService,
        private modalService: BsModalService,
        private subscriptionService: SubscriptionService
    ) {
        this.subscriptionService.listForLeads().subscribe((subscriptions) => {
            this.subscriptions = subscriptions
            this.getClientsWithPrivateInfo()
        })
    }

    ngOnInit(): void {}

    getClientsWithPrivateInfo() {
        const clientsRef = query(collection(this.adminSvc.firestore, clientsPath()), orderBy('createdAt', 'desc'), limit(200))
        const clientsPrivateRef = query(collection(this.adminSvc.firestore, adminClientsPath()), orderBy('createdAt', 'desc'))

        combineLatest([collectionData(clientsRef, { idField: 'documentId' }), collectionData(clientsPrivateRef, { idField: 'documentId' })])
            .pipe(
                map(([clientsData, clientsPrivateData]) => {
                    const clientsPrivateMap = new Map(clientsPrivateData.map((clientPrivate: any) => [clientPrivate.documentId, clientPrivate]))
                    return clientsData
                        .filter(
                            (clientData: any) =>
                                !this.subscriptions.some((subscription) => {
                                    return subscription.clientRef?.id === clientData.documentId
                                })
                        )
                        .map((clientData: any) => {
                            const clientPrivate = clientsPrivateMap.get(clientData.documentId)

                            if (clientPrivate) {
                                return {
                                    ...clientData,
                                    // ...clientPrivate,
                                    $key: clientData.documentId,
                                    $email: clientPrivate.email,
                                    $phoneNumber: clientPrivate.phoneNumber,
                                }
                            }

                            return {
                                ...clientData,
                                $key: clientData.documentId,
                            }
                        })
                })
            )
            .subscribe((clients: any[]) => {
                this.clients = clients
                console.log(this.clients)
            })
    }

    closeSaveFormModal() {
        this.modalRef?.hide()
    }

    openModal(template: any, clientKey: string) {
        this.clientKey = clientKey
        this.modalRef = this.modalService.show(template, { class: 'modal-lg' })
    }

    onSubmit() {
        this.loading = true
        this.changeClientPassword(this.clientKey)
    }

    changeClientPassword(clientKey: any) {
        this.authService.user.getIdToken(true).then((idToken) => {
            this.authService.changeClientPassword(clientKey, this.formGroup.value.password, idToken).subscribe((response) => {
                if (response.successful) {
                    this.loading = false
                    this.closeSaveFormModal()
                    this.toastrService.success('', response.displayMessage)
                } else {
                    this.loading = false
                    this.toastrService.error('Error', response.error)
                }
            })
        })
    }
}
